import React from "react";
import "./footer2.css";

const Footer2 = () => {
  return (
    <div className="site-footer">
      <div className="site-footer__social" aria-label="Social links">
        <a
          href="https://www.linkedin.com/in/andersonjavian/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
        >
          <i className="fab fa-linkedin"></i>
        </a>
        <a
          href="https://www.instagram.com/javian.zinga/"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://twitter.com/manueljanderson"
          target="_blank"
          rel="noreferrer"
          aria-label="Twitter"
        >
          <i className="fab fa-twitter"></i>
        </a>
        <a
          href="https://www.facebook.com/OfficialManuel1"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
        >
          <i className="fab fa-facebook"></i>
        </a>
      </div>
      <p>
        &copy;2022&ndash;{new Date().getFullYear()} Zing Studios, by Javian
        Anderson. All rights reserved.
      </p>
    </div>
  );
};

export default Footer2;
